import styled, { css } from 'styled-components';
import { Color } from '../../common/base';

const SecurityWrapper = styled.div`
  background-color: ${({ theme: { colors } }) => colors.gray.light};
`;

const CertificateWrapper = styled.img`
  padding: 10px;
  border-radius: 10px;
  background-color: #fff;
  box-shadow: 0 0 10px 0 #dadada;
  transition: all 0.2s;
  width: 640px;
  max-width: 90vw;

  &:hover {
    box-shadow: 0 0 10px 5px #ddd;
  }
`;

export { SecurityWrapper, CertificateWrapper };
